import React from 'react';

const TenantStoriesSection = ({ imgSrc, altText }) => {
  return (
    <section className="relative overflow-hidden">
      <div className="mx-auto">
        <div className="grid md:grid-cols-2">
          {/* Left Column - Blue Background with Text */}
          <div className="bg-[#336fb8] p-10">
            <h2 className="text-6xl font-bold text-white mb-6 font-arial-rounded">
              Tenant Stories
            </h2>
            <p className="text-white text-lg leading-relaxed">
              Lindsay was our very first participant and we owe a great deal to him and his family for trusting Livability Care Australia to provide him supported accommodation and care. Lindsay has improved so much, both mentally and physically from the day we met him to now. Being stuck in a rehabilitation centre for years and not having a life to moving into his forever home is such an achievement for him as well as us. Lindsay is a cheerful gentleman who loves hanging out with his housemates, going out for coffee and cake, watching footy, and going out.
            </p>
          </div>

          {/* Right Column - Image */}
          <div className="relative">
            <div className="relative h-full">
              <img
                src={imgSrc || "/lindey.png"}  // Default to '/lindey.png' if no imgSrc is provided
                alt={altText || "Tenant with guitar"} // Default alt text
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute bottom-4 right-4 p-10">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TenantStoriesSection;
